<template>
    <div class="app">
        <!-- 切换语言 -->
        <div class="language" @click="setLanguage">
            {{type=="machineqr"?"":(language=="zh-CN"?"ENGLISH":"中文")}}
        </div>

        <!-- 文档列表 -->
        <div class="document-list" :style="{height: type=='machineqr'?'100%':'calc(100% - 30px)'}">
            <!-- 加载状态 -->
            <div v-if="loading" class="loading">
                {{$t('l.hint46')}}
            </div>

            <!-- 无数据状态 -->
            <div v-else-if="this.documents.length === 0" class="no-data">
                {{$t('l.no_datas')}}
            </div>

            <!-- 文档列表 -->
            <div v-else>
                <div
                        v-for="(doc, index) in documents"
                        :key="index" class="instructions"
                >
                    <div class="info">
                        <div class="icon" @click="downLoadPDF(index)">
                            <img src="../../../public/images/wx/download.png">
                        </div>
                        <div class="name">{{doc.name}}</div>
                    </div>
                    <div class="size">
                        <span>{{doc.size}}</span>
                        <a :href="'http://qr.sylg.cn/a.php/qr/instructions/?file='+doc.url" target="_blank">{{$t('l.preview')}}</a>
                        <a href="javascript:void(0);" @click="downLoadPDF(index)">{{$t('l.download')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js';

    export default {
        name: "page-qrdetail",
        data() {
            return {
                language: 'zh-CN',
                loading: false,
                id: '',
                type: '',
                documents: [],
                instructions: [],
            }
        },
        methods: {
            fetchDocument() {
                this.loading = true;
                util.ajax.post('/wx/qr/getDocumentInfo', {
                    params: {
                        id: this.id,
                        type: this.type,
                    }
                }).then((res) => {
                    this.loading = false;
                    if (res.code == 0) {
                        this.documents = [];
                        if (this.type == "qr") {
                            var instructions = res.data.instructions;
                            if (instructions) {
                                instructions = JSON.parse(instructions);
                            } else {
                                instructions = [];
                            }
                            this.instructions = instructions;
                            this.changeDocuments();
                        }
                        if (this.type == "machineqr") {
                            this.documents.push({
                                name: res.data.filename,
                                size: res.data.size,
                                url: "/" + res.data.url,
                            });
                        }
                    }
                }).catch(e => {
                    this.loading = false;
                });
            },
            changeDocuments() {
                var type = this.language == "zh-CN" ? 0 : 1;
                for (var i = 0; i < this.instructions.length; i++) {
                    var iInfo = this.instructions[i];
                    if (iInfo.type == type) {
                        this.documents.push({
                            name: iInfo.name,
                            size: this.sizeTostr(iInfo.size),
                            url: iInfo.file,
                        });
                    }
                }
            },
            downLoadPDF(index) {
                var ua = window.navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    if (this.language == "zh-CN") alert("由于微信功能的限制，请点击右上角\"···\"，选择\"在浏览器打开\"，然后进入浏览器进行下载");
                    else alert("Due to limitations in WeChat functionality, please click on the \"····\" in the upper right corner, select \"Open in Browser\", and then enter the browser to download");
                } else {
                    var documentInfo = this.documents[index];
                    location.href = "http://qr.sylg.cn/download.php?name=" + documentInfo.name + "&file=" + documentInfo.url;
                }
            },
            sizeTostr(size) {
                var data = "";
                if (size < 0.1 * 1024) {
                    data = size.toFixed(2) + "B";
                } else if (size < 0.1 * 1024 * 1024) {
                    data = (size / 1024).toFixed(2) + "KB";
                } else if (size < 0.1 * 1024 * 1024 * 1024) {
                    data = (size / (1024 * 1024)).toFixed(2) + "MB";
                } else {
                    data = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
                }
                var sizestr = data + "";
                var len = sizestr.indexOf("\.");
                var dec = sizestr.substr(len + 1, 2);
                if (dec == "00") {
                    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
                }
                return sizestr;
            },
            setLanguage() {
                this.language = this.language == "zh-CN" ? "en-US" : "zh-CN";
                this.documents = [];
                this.changeDocuments();
            }
        },
        mounted: function () {
            this.id = this.$route.query.id;
            this.type = this.$route.query.type;
            this.language = this.$route.query.language;
            this.fetchDocument();
        },
    }
</script>


<style scoped>
    .app {
        height: 100%;
        width: 100%;
        padding: 15px;
        background-image: url("../../../public/images/wx/qr_top.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-color: #f5f5f5;
        box-sizing: border-box;
    }

    /* 切换语言 */
    .language {
        cursor: pointer;
        font-size: 18px;
        font-weight: bold;
        color: white;
        width: 100%;
        text-align: end;
        margin-top: -5px;
        margin-bottom: 5px;
    }

    /* 文档列表 */
    .document-list {
        background-color: #fff;
        border-radius: 8px;
        padding: 0 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        margin-bottom: 15px;
        height: calc(100% - 30px);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* 加载状态 */
    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        font-size: 14px;
        color: #666;
    }

    .loading::after {
        content: '';
        width: 20px;
        height: 20px;
        margin-left: 10px;
        border: 2px solid #f3f3f3;
        border-top: 2px solid #4CAF50;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /* 无数据状态 */
    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: 14px;
        color: #999;
    }

    .instructions {
        height: 60px;
        border: 1px solid #2a9fff;
        border-radius: 30px;
        width: 90%;
        min-width: 90%;
        max-width: 90%;
        margin-bottom: 25px;
        margin-left: 5%;
        position: relative;
        padding-right: 10px;
    }

    .instructions .info {
        display: flex;
        justify-content: left;
        align-items: center;
        height: 100%;
        width: 100%;
    }

    .instructions .info .icon {
        min-width: 60px;
        width: 60px;
        height: 60px;
        background: #2a9fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .instructions .info .icon img {
        width: 70%;
    }

    .instructions .info .name {
        padding: 0 3px 0 3px;
        font-size: 14px;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-align: left;
        line-height: 15px;
        display: -webkit-box;
        margin-top: -15px;
    }

    .instructions .size {
        position: absolute;
        right: 20px;
        bottom: 0;
        color: #708090;
    }

    .instructions .size a {
        margin-left: 10px;
        cursor: pointer;
        color: #2a9fff;
    }

    .instructions .size a:last-child {
        margin-left: 7px;
    }
</style>